import ScreenMain from '../screens/ScreenMain';
import ScreenAuthenticated from '../screens/ScreenAuthenticated';
import ScreenBoard from '../screens/ScreenBoard';
import ScreenConfigure from '../screens/ScreenConfigure';
import ScreenConfigureWizardObject from '../screens/ScreenConfigureWizardObject';
import ScreenConfigureRestore from '../screens/ScreenConfigureRestore';
import ScreenConfigureGroups from '../screens/ScreenConfigureGroups';
import ScreenConfigureBoard from '../screens/ScreenConfigureBoard';
import ScreenConfigureBoards from '../screens/ScreenConfigureBoards';
import ScreenConfigureGroup from '../screens/ScreenConfigureGroup';
import ScreenConfigureObject from '../screens/ScreenConfigureObject';
import ScreenConfigureDevice from '../screens/ScreenConfigureDevice';
import ScreenConfigureDevices from '../screens/ScreenConfigureDevices';
import ScreenConfigureObjects from '../screens/ScreenConfigureObjects';
import ScreenConfigureRooms from '../screens/ScreenConfigureRooms';
import ScreenConfigureCamera from '../screens/ScreenConfigureCamera';
import ScreenConfigureCameras from '../screens/ScreenConfigureCameras';
import ScreenConfigureTrigger from '../screens/ScreenConfigureTrigger';
import ScreenConfigureAutomation from '../screens/ScreenConfigureAutomation';
import ScreenConfigureAutomations from '../screens/ScreenConfigureAutomations';
import ScreenConfigureSchedules from '../screens/ScreenConfigureSchedules';
import ScreenConfigureIntegrations from '../screens/ScreenConfigureIntegrations';
import ScreenConfigureIntegration from '../screens/ScreenConfigureIntegration';
import ScreenConfigureMQTT from '../screens/ScreenConfigureMQTT';
import ScreenConfigurePresenceDetectors from '../screens/ScreenConfigurePresenceDetectors';
import ScreenConfigureNotifications from '../screens/ScreenConfigureNotifications';
import ScreenCameraView from '../screens/ScreenCameraView';
import ScreenDebugTopics from '../screens/ScreenDebugTopics';
import ScreenDebugTopicFamily from '../screens/ScreenDebugTopicFamily';
import ScreenCommandLog from '../screens/ScreenCommandLog';
import ScreenEngineFlags from '../screens/ScreenEngineFlags';
import ScreenTimestamp from '../screens/ScreenTimestamp';
import ScreenUUID from '../screens/ScreenUUID';
import Screen2FA from '../screens/Screen2FA';
import ScreenFIDO from '../screens/ScreenFIDO';
import ScreenRunByPin from "../screens/ScreenRunByPin";
import ScreenEvents from '../screens/ScreenEvents';
import ScreenObjectQuickView from '../screens/ScreenObjectQuickView';
import ScreenChart from '../screens/ScreenChart';
import ScreenChartLiniar from '../screens/ScreenChartLiniar';
import ScreenChartGantt from '../screens/ScreenChartGantt';
import ScreenLog from '../screens/ScreenLog';
import ScreenAutomationsLog from '../screens/ScreenAutomationsLog';
import ScreenTools from '../screens/ScreenTools';
import ScreenDevicesLocations from '../screens/ScreenDevicesLocations';
import ScreenRequester from '../screens/ScreenRequester';
import ScreenRequesterRequest from '../screens/ScreenRequest';
import ScreenRequesterCollection from '../screens/ScreenRequesterCollection';
import ScreenLogout from '../screens/ScreenLogout';
import ScreenAbout from '../screens/ScreenAbout';
import Screen404 from '../screens/Screen404';

import store from '../store/store';

export default [
  {
    path: '/',
    name: 'Main',
    component: ScreenMain
  },
  {
    path: '/pin',
    name: 'RunByPin',
    component: ScreenRunByPin,
    props: true
  },
  {
    path: '/boards/:id',
    name: 'Board',
    component: ScreenBoard,
    beforeEnter(to, from, next) {
      const board = store.getters['objects/boardById'](to.params.id);
      if (!board) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/authenticated',
    name: 'Authenticated',
    component: ScreenAuthenticated,
    props: true
  },
  {
    path: '/objects/:id',
    redirect: (to) => {
      return '/configure/objects/' + to.params.id;
    }
  },
  {
    path: '/configure/rooms',
    name: 'Configure Rooms',
    component: ScreenConfigureRooms,
    props: true
  },
  {
    path: '/configure/cameras',
    name: 'Configure Cameras',
    component: ScreenConfigureCameras,
    props: true
  },
  {
    path: '/configure/cameras/:id',
    name: 'Configure Camera',
    component: ScreenConfigureCamera,
    beforeEnter(to, from, next) {
      const camera = store.getters['cameras/cameraById'](to.params.id);
      if (!camera) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/configure/restore',
    name: 'Configure Restore',
    component: ScreenConfigureRestore
  },
  {
    path: '/configure/groups',
    name: 'Configure Groups',
    component: ScreenConfigureGroups,
    props: true
  },
  {
    path: '/configure/boards/:id',
    name: 'Configure Board',
    component: ScreenConfigureBoard,
    beforeEnter(to, from, next) {
      const board = store.getters['objects/boardById'](to.params.id);
      if (!board) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/configure/boards',
    name: 'Configure Boards',
    component: ScreenConfigureBoards,
    props: true
  },
  {
    path: '/configure/group/:id',
    name: 'Configure Group',
    component: ScreenConfigureGroup,
    beforeEnter(to, from, next) {
      const group = store.getters['objects/groupById'](to.params.id);
      if (!group) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/configure/objects/:id',
    name: 'Configure Object',
    component: ScreenConfigureObject,
    beforeEnter(to, from, next) {
      const obj = store.getters['objects/objectById'](to.params.id);
      if (!obj) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/configure/objects',
    name: 'Configure Objects',
    component: ScreenConfigureObjects,
    props: true
  },
  {
    path: '/configure/triggers/:id',
    name: 'Configure Trigger',
    component: ScreenConfigureTrigger,
    beforeEnter(to, from, next) {
      const obj = store.getters['triggers/triggerById'](to.params.id);
      if (!obj) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/configure/automations',
    name: 'Configure Automations',
    component: ScreenConfigureAutomations,
    props: true
  },
  {
    path: '/tools/timestamp',
    name: 'Timestamp',
    component: ScreenTimestamp,
    props: true
  },
  {
    path: '/tools/uuid',
    name: 'UUID',
    component: ScreenUUID,
    props: true
  },
  {
    path: '/tools/2fa',
    name: '2FA',
    component: Screen2FA,
    props: true
  },
  {
    path: '/tools/fido',
    name: 'FIDO',
    component: ScreenFIDO,
    props: true
  },
  {
    path: '/configure/notifications',
    name: 'Configure Notifications',
    component: ScreenConfigureNotifications,
    props: true
  },
  {
    path: '/configure/automations/:id',
    name: 'Configure Automation',
    component: ScreenConfigureAutomation,
    props: true,
    beforeEnter(to, from, next) {
      const obj = store.getters['automations/automationById'](to.params.id);
      if (!obj) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/configure/schedules',
    name: 'Configure Schedules',
    component: ScreenConfigureSchedules,
    props: true
  },
  {
    path: '/configure/devices/:id',
    name: 'Configure Device',
    component: ScreenConfigureDevice,
    beforeEnter(to, from, next) {
      const obj = store.getters['devices/deviceById'](to.params.id);
      if (!obj) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/configure/devices',
    name: 'Configure Devices',
    component: ScreenConfigureDevices,
    props: true
  },
  {
    path: '/configure/integrations',
    name: 'Configure Integrations',
    component: ScreenConfigureIntegrations,
    props: true
  },
  {
    path: '/configure/integrations/:id',
    name: 'Configure Integration',
    component: ScreenConfigureIntegration,
    beforeEnter(to, from, next) {
      const group = store.getters['integrations/integrationById'](to.params.id);
      if (!group) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/configure/wizard/object/:topicId',
    name: 'Wizard Create Object',
    component: ScreenConfigureWizardObject
  },
  {
    path: '/cameras/:id',
    name: 'Camera View',
    component: ScreenCameraView,
    props: true,
    beforeEnter(to, from, next) {
      const camera = store.getters['cameras/cameraById'](to.params.id);
      if (!camera) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/configure/mqtt',
    name: 'Configure MQTT',
    component: ScreenConfigureMQTT,
    props: true
  },
  {
    path: '/configure/pd',
    name: 'Configure Presence Detectors',
    component: ScreenConfigurePresenceDetectors,
    props: true
  },
  {
    path: '/log/commands',
    name: 'View Commands Log',
    component: ScreenCommandLog,
    props: true
  },
  {
    path: '/log/automations',
    name: 'Automations Log',
    component: ScreenAutomationsLog,
    props: true
  },
  {
    path: '/log',
    name: 'View Log',
    component: ScreenLog,
    props: true
  },
  {
    path: '/configure',
    name: 'Configure',
    component: ScreenConfigure,
    props: true
  },
  {
    path: '/debug/topics',
    name: 'Debug Topics',
    component: ScreenDebugTopics,
    props: true
  },
  {
    path: '/debug/topic/:index',
    name: 'Debug Topic Family',
    component: ScreenDebugTopicFamily,
    props: true
  },
  {
    path: '/tools',
    name: 'Tools',
    component: ScreenTools,
    props: true
  },
  {
    path: '/tools/devices/locations',
    name: 'Devices Locations',
    component: ScreenDevicesLocations,
    props: true
  },
  {
    path: '/tools/requester',
    name: 'Requester',
    component: ScreenRequester,
    props: true
  },
  {
    path: '/tools/requester/request',
    name: 'Request',
    component: ScreenRequesterRequest,
    props: true
  },
  {
    path: '/tools/requester/collections/:id',
    name: 'Collection',
    component: ScreenRequesterCollection,
    props: true,
    beforeEnter(to, from, next) {
      const obj = store.getters['requester/collectionById'](to.params.id);
      if (!obj) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/events',
    name: 'Events',
    component: ScreenEvents,
    beforeEnter(to, from, next) {
      const filters = {};
      if (to.query.objectTypeId) {
        filters['objectTypeId'] = parseInt(to.query.objectTypeId);
      }
      if (to.query.objectId) {
        filters['objectId'] = parseInt(to.query.objectId);
      }
      if (to.query.timeFrameId) {
        filters['timeFrameId'] = parseInt(to.query.timeFrameId);
      }
      if (Object.keys(filters).length > 0) {
        store.commit('events/SET_FILTERS', filters, { root: true });
      }

      next();
    },
    props: true
  },
  {
    path: '/flags',
    name: 'Engine Flags',
    component: ScreenEngineFlags
  },
  {
    path: '/view/:objectId',
    name: 'Quick View',
    component: ScreenObjectQuickView,
    beforeEnter: (to, from, next) => {
      const object = store.getters['objects/objectById'](to.params.objectId);
      if (!object) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/chart/:objectId',
    name: 'Chart',
    component: ScreenChart,
    beforeEnter: (to, from, next) => {
      const object = store.getters['objects/objectById'](to.params.objectId);
      if (!object) {
        return next('/404');
      }

      store.commit('ui/SHOW_OVERLAY', true, { root: true });
      store.dispatch('graphs/fetchGraph', {
        objectId: object.id,
        useOverlay: false,
        cb: (err, data) => {
          if (err) {
            /* eslint-disable */
            console.log(err);
            return;
          }

          /* eslint-disable */
          console.log(data);
          if (data.timeFrameId) {
            store.commit('events/SET_SELECTED_TIME_FRAME', data.timeFrameId, { root: true });
          }
          store.commit('graphs/SET_GRAPH', data, { root: true });
          next();
        }
      }, { root: true });
    }
  },
  {
    path: '/chart/liniar/:objectId',
    name: 'Chart Liniar',
    component: ScreenChartLiniar,
    beforeEnter: (to, from, next) => {
      const object = store.getters['objects/objectById'](to.params.objectId);
      if (!object) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/chart/gantt/:objectId',
    name: 'Chart Gantt',
    component: ScreenChartGantt,
    beforeEnter: (to, from, next) => {
      const object = store.getters['objects/objectById'](to.params.objectId);
      if (!object) {
        return next('/404');
      }

      next();
    }
  },
  {
    path: '/about',
    name: 'About',
    component: ScreenAbout,
    props: true
  },
  {
    path: '/logout',
    name: 'Logout',
    component: ScreenLogout,
    props: true
  },
  {
    path: '/404',
    component: Screen404
  },
  {
    path: '*',
    redirect: '/404'
  }
];
